<template>
  <!--<div class="bg">-->
    <div class="container">
      <div class="banner">
        <div class="context">
          <div class="phonePic">
            <img src="/static/img/app/phonePic.png">
          </div>
          <div>
            <p class="bannerTit mart114">木材码头全新升级</p>
            <p class="bannerCon">木材行业交易平台 APP，邀你共享<span class="edition">v2.2.1</span></p>
            <p class="btn">
              <a href="http://app.emulian.com/download/android/" class="na_app_btn"></a>
              <a href="http://app.emulian.com/download/ios/" class="ios_app_btn marl50"></a>
              <div class="clear"></div>
            </p>
          </div>
        </div>
      </div>
    </div>
  <!--</div>-->
</template>

<script>
  export default{
    name: 'homeAppBanner'
  }
</script>

<style scoped>
  div.bg {
    display: flex;
    height: auto;
  }
  div.container {
    width: auto;
    height: auto;
    margin: 0;
    /*display: flex;*/
    padding: 0;
    /*width: 1100px;*/
    /*margin: auto;*/
    /*height: auto;*/
  }
  div.banner {
    width: 100%;
    height: 360px;
    background: url("/static/img/app/app-banner.png") no-repeat top left;
    background-size: 100% 100%;
    display: flex;
  }
  div.banner .context{
    width: 800px;
    margin: 0 auto;
    height: 360px;
  }
  div.banner .context div{
    float: left;
    position: relative;
    z-index: 50;
  }
  div.banner .context div.phonePic{
    position: relative;
    margin-right: 82px;
    width: 190px;
    height: 360px;
  }
  div.banner .context div img{
    position: absolute;
    top: 70px;
    height: 360px;
    width: 190px;
  }
  div.banner .context div p.mart114{
    margin-top: 114px;
  }
  div.banner .context div p.bannerTit{
    font-size: 60px;
    color: #fff;
  }
  div.banner .context div p.bannerCon{
    font-size: 26px;
    color: #fff;
  }
  div.banner .context div p span.edition{
    font-size: 20px;
    color: #fff;
    background: none;
    font-weight: normal;
    border: 1px solid #e2e2e2;
    margin-left: 28px;
    padding: 3px 6px;
    border-radius: 6px;
  }

  div.banner .context div p a{
    height: 60px;
    width: 214px;
    float: left;
  }
  div.banner .context div p a.na_app_btn{
    background: url("/static/img/app/na_app_btn.png") no-repeat left top;
    background-size: 214px 60px;
  }
  div.banner .context div p a.ios_app_btn{
    background: url("/static/img/app/ios_app_btn.png") no-repeat left top;
    background-size: 214px 60px;
  }
  div.banner .context div p a.marl50{
    margin-left: 50px;
  }
  span {
    width: auto;
    font-weight: 700;
    font-style: normal;
    font-family: 'Helvetica-Bold', 'Helvetica Bold', 'Helvetica';
    background-color:  rgba(215, 215, 215, 1);
    font-size: 32px;
    white-space: nowrap;
    color: #333333;
  }
  div.line {
    margin-left: 12%;
  }
  img {
    width: 100%;
    height: 100%
  }
</style>



// WEBPACK FOOTER //
// HomeAppBanner.vue?215a18c9